import React from "react"

import styles from "./ShopProgress.module.css";

function ShopProgress({isFirst, isSecond, isThird, isLast}) {
	return (
		<>
			<div className={styles.progressWrap}>
				<ul>
					<li>
						<span style={ isFirst ? { color : 'var(--basic-white)', backgroundColor : 'var(--theme-primary-blue)', border : 'none'} : {} }>01</span>
						<h3 style={ isFirst ? { fontWeight:'600', color : 'var(--basic-black)', borderBottom : '2px solid var(--theme-primary-blue)'} : {} }>품목선택</h3>
					</li>
					<li>
						<span style={ isSecond ? { color : 'var(--basic-white)', backgroundColor : 'var(--theme-primary-blue)', border : 'none'} : {} }>02</span>
						<h3 style={ isSecond ? { fontWeight:'600', color : 'var(--basic-black)', borderBottom : '2px solid var(--theme-primary-blue)'} : {} }>품목확인</h3>
					</li>
					<li>
						<span style={ isThird ? { color : 'var(--basic-white)', backgroundColor : 'var(--theme-primary-blue)', border : 'none'} : {} }>03</span>
						<h3 style={ isThird ? { fontWeight:'600', color : 'var(--basic-black)', borderBottom : '2px solid var(--theme-primary-blue)'} : {} }>정보확인</h3>
					</li>
					<li>
						<span style={ isLast ? { color : 'var(--basic-white)', backgroundColor : 'var(--theme-primary-blue)', border : 'none'} : {} }>04</span>
						<h3 style={ isLast ? { fontWeight:'600', color : 'var(--basic-black)', borderBottom : '2px solid var(--theme-primary-blue)'} : {} }>주문결제</h3>
					</li>
				</ul>
			</div>
		</>
	)
}

export default ShopProgress
